import ReactSVG from "react-svg"
import React, { useEffect, useState } from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { navigationPaths } from "../constants/paths"
import SplitClient, { SFO_FLAG, VALVOLINE_BANNER } from "./config/SplitClient"
import { getSubdomain } from "./shared/StylesheetInjector"

const Valvoline = ({ vehicle, history, user }) => {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    async function getFlag() {
      const result = await SplitClient.getTreatment(VALVOLINE_BANNER, user, {
        sub_domain: getSubdomain(),
        app_name: getSubdomain()
      })
      setShowBanner(result[VALVOLINE_BANNER] === "on")
    }
    getFlag()
  }, [user])

  const subdomain = getSubdomain()

  const requestService = () => {
    history.push({
      pathname: navigationPaths.serviceRequestNew(),
      state: {
        previousFormData: {
          vehicle_id: vehicle && vehicle.id,
          vehicle: vehicle
        }
      }
    })
  }

  if (!showBanner) {
    return null
  }

  return (
    <>
      <div className="w-full mt-5 hidden lg:block">
        <ReactSVG
          src={`/images/valvoline/valvoline-${subdomain}-large.svg`}
          className="cursor-pointer"
          onClick={requestService}
        />
      </div>
      <div className="w-full mt-5 hidden md:block lg:hidden">
        <ReactSVG
          src={`/images/valvoline/valvoline-${subdomain}-medium.svg`}
          className="cursor-pointer"
          onClick={requestService}
        />
      </div>
      <div className="w-full mt-5 block md:hidden">
        <ReactSVG
          src={`/images/valvoline/valvoline-${subdomain}-mobile.svg`}
          className="cursor-pointer"
          onClick={requestService}
        />
      </div>
    </>
  )
}

function mapStateToProps(state) {
  const user = state.application.userSessionData || (state.users && state.users.currentUser)
  return {
    user
  }
}
export const ValvolineBanner = withRouter(connect(mapStateToProps)(Valvoline))
